import api from './api';
import { Stats } from '../types';

export interface TrailProgressUser {
  userId: string;
  name: string;
  email: string;
  isPremium: boolean;
  currentDay: number;
  completed: boolean;
  lastViewedAt: string | null;
  nextUnlockAt: string | null;
}

export interface TrailProgressSummary {
  id: string;
  title: string;
  isPremium: boolean;
  totalDays: number;
  daysWithVideo: number;
  activeUsers: number;
  users: TrailProgressUser[];
  priorityDays: { day: number; hasVideo: boolean; users: number }[];
  missingSoon: number[];
}

export interface TrailProgressResponse {
  window: number;
  trails: TrailProgressSummary[];
}

export type OverviewPeriod = 7 | 30 | 90;

export interface DashboardOverview {
  range: { days: OverviewPeriod; from: string; to: string };
  users: {
    total: number;
    internalExcluded: number;
    new: number;
    newPrevious: number;
    active7: number;
    active30: number;
    withPush: number;
  };
  subscriptions: {
    paying: number;
    trial: number;
    courtesy: number;
    mrr: number;
    byPlan: { monthly: number; annual: number };
  };
  engagement: {
    completions: number;
    completionsPrevious: number;
    learners: number;
  };
  series: { date: string; signups: number; completions: number; learners: number }[];
  lastActive: {
    today: number;
    days1to2: number;
    days3to6: number;
    days7to13: number;
    days14to29: number;
    days30plus: number;
    never: number;
  };
  funnel: {
    signedUp: number;
    startedTrail: number;
    firstDevotional: number;
    sevenDevotionals: number;
    activeLast7: number;
  };
  trails: { id: string; title: string; inProgress: number; active7: number; completed: number }[];
  recentUsers: {
    id: string;
    name: string;
    email: string;
    createdAt: string;
    lastActiveAt: string | null;
    isPremium: boolean;
    via: 'google' | 'email';
  }[];
  pendingComments: number;
}

export const statsService = {
  /** Visão geral do dashboard no período (sem contas internas) */
  getOverview: async (days: OverviewPeriod): Promise<DashboardOverview> => {
    const response = await api.get('/admin/stats/overview', { params: { days } });
    return response.data;
  },

  getStats: async (): Promise<Stats> => {
    const response = await api.get('/admin/stats');
    return response.data;
  },

  /** Em que dia cada pessoa está e quais dias precisam de vídeo primeiro */
  getTrailProgress: async (window = 14): Promise<TrailProgressResponse> => {
    const response = await api.get('/admin/stats/trail-progress', {
      params: { window },
    });
    return response.data;
  },
};
